import { ViewModelProperty } from '@ldw/roesberg';
import { NavigationMode } from '../shared/enums/navigation-mode';

export class SearchDefinition {
  public luceneSearchField: ViewModelProperty | undefined = undefined;
  public databaseSearchField: ViewModelProperty | undefined = undefined;
  public docStatusSearchField: ViewModelProperty | undefined = undefined;
  public docFields: ViewModelProperty[] = [];
  public nodeFields: ViewModelProperty[] = [];
  public loopFields: ViewModelProperty[] = [];
  public lncFields: ViewModelProperty[] = [];
  public lsnFields: ViewModelProperty[] = [];
  public customFields: ViewModelProperty[] = [];

  // properties needed to restore last settings
  public isWildCard = false;
  public searchMetaData = false;
  public navigationMode: NavigationMode = NavigationMode.Documents;

  public clearInput() {
    this.clearVMP(this.luceneSearchField);
    this.clearVMP(this.databaseSearchField);
    this.clearVMP(this.docStatusSearchField);
    this.clearVMPGroup(this.docFields);
    this.clearVMPGroup(this.nodeFields);
    this.clearVMPGroup(this.loopFields);
    this.clearVMPGroup(this.lncFields);
    this.clearVMPGroup(this.lsnFields);
    this.clearVMPGroup(this.customFields);
    this.navigationMode = NavigationMode.Documents;
    this.searchMetaData = false;
    this.isWildCard = false;
  }

  private clearVMP(vmp: ViewModelProperty | undefined) {
    if (vmp != null) {
      vmp.value = vmp.initialValue;
    }
  }

  private clearVMPGroup(nodeFields: ViewModelProperty[]) {
    if (nodeFields == null) return;
    nodeFields.forEach((vmp) => {
      this.clearVMP(vmp);
    });
  }
}
